<div class="mct-flex mct-col mct-gap-27"   *ngFor="let optionType of eCommerceItem.ItemOptionTypes; let rowIndex = index">
  <wl-ecom-item-edit-options [ecomOptionType]="optionType"></wl-ecom-item-edit-options>
</div>
